export const apiPath = '/v2/card_templates';
const actionType = 'CARD_TEMPLATE';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
